import { useState } from "react"

import useMountEffect from "@p-ban/common/src/hooks/useMountEffect"

import { getCouponCode } from "../../../logic/coupon/referralLink"
import signUpApi from "../api/signUpApi"
import { SignUpFormContext } from "../context/SignUpFormContext"
import type SignUpFormValues from "../types/SignUpFormValues"
import SignUpInvalid from "./SignUpInvalid"

const SignUpFormProvider = ({ children }: { children: React.ReactNode }) => {
  const [values, setSignUpForm] = useState<SignUpFormValues>({
    personalOrCorporate: null,
    loginEmail: "",
    password: "",
    corporateName: "",
    corporateNameKana: "",
    userFamilyName: "",
    userFirstName: "",
    phoneNumber: "",
    userAdvertisingMediaCode: null,
    serviceToUse: [],
    couponCode: "",
    validateKey: "",
  })

  const [isInvalid, setIsInvalid] = useState(false)
  useMountEffect(() => {
    const validateKey = new URLSearchParams(window.location.search).get("validateKey") ?? ""
    signUpApi.check(validateKey).then((result) => {
      if (result.isSuccess) {
        setSignUpForm((prev) => ({
          ...prev,
          loginEmail: result.data.email,
          couponCode: getCouponCode() ?? "",
          validateKey,
        }))
      } else {
        setIsInvalid(true)
      }
    })
  })

  const [wasSignedUp, setWasSignedUp] = useState(false)

  if (isInvalid) {
    return <SignUpInvalid />
  }

  const value = { values, setValues: setSignUpForm, wasSignedUp, setWasSignedUp }

  return <SignUpFormContext.Provider value={value}>{children}</SignUpFormContext.Provider>
}

export default SignUpFormProvider
